// extracted by mini-css-extract-plugin
module.exports = {"dot":"RatingDots-module__dot___FQoJ7","ratingDots":"RatingDots-module__ratingDots___HW9jL"};